<!-- form panel -->
<div class="p-1">
  <div class="rounded p-1">
    <div class="w-100 d-flex justify-content-left align-items-center pb-0 pt-0">
      <button class="btn btn-light btn-xs" id="add-btn" data-toggle="collapse" href="#collapseExampleAdd"
        aria-expanded="true" aria-controls="collapseExampleAdd">
        <span class="dripicons-chevron-up" id="add-btn-up"></span>
        <span class="dripicons-chevron-down" id="add-btn-down"></span>
      </button>
      <h5 class="ml-2 text-dark d-flex align-items-center">Commission Setup</h5>
      <div class="d-flex ml-auto">
        <!-- Standard modal -->
        <button type="button" class="btn btn-primary btn-sm" title="Save">Save</button>
      </div>
    </div>

    <div class="collapse show" id="collapseExampleAdd">
      <!-- <div class="m-1 p-2"> -->
        <!-- <div> -->
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="enableAccessoriesOnSale">
            <label class="custom-control-label" for="enableAccessoriesOnSale">Enable Commission</label>
        </div>
        <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="enablePackagesOnSale">
            <label class="custom-control-label" for="enablePackagesOnSale">Allow Customized Commission Structure by Employee</label>
        </div>
          <!-- <div class="form-check">
            <input type="checkbox" class="form-check-input">
            <label class="form-check-label" for="customCheck1"></label>
          </div>
        <div class="form-check mt-2">
          <input type="checkbox" class="form-check-input">
          <label class="form-check-label" for="customCheck1"></label>
        </div> -->
        <!-- </div> -->
      <!-- </div> -->
      <div class="row m-1">
        <div class="col-md-12 p-2">
          <div class="card">
            <div class="card-header row d-flex">
              <h5>Commission Structure</h5>
              <!-- <div class="ml-auto">
                <div class="row">
                  <label for="inputEmail3" class="col-4 col-form-label">Effective On</label>
                  <div class="col-8">
                    <input type="date" class="form-control">
                  </div>
                </div>
              </div> -->
            </div>
            <div class="card-body">
              <!-- <h6 class="card-title">The commission structure below is for the salesperson.</h6> -->
              <table class="table table-responsive text-dark">
                <tbody>
                  <tr class="d-flex align-items-center">
                    <td>1</td>
                    <td><input type="number" class="form-control form-control-sm w-45 mb-1 justify-content-center"></td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <!-- <small for="SaleId">Sale</small> -->
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12">
                              <option>Flat Rate</option>
                              <option>%</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>Per</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <!-- <small for="SaleId"></small> -->
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12">
                              <option>Down Payment</option>
                              <option>Sale Front End Profit</option>
                              <option>Sale Back End Profit</option>
                              <option>Scheduled Installment Payment</option>
                              <option>Deferred Down Payment</option>
                              <option>CPI Payment</option>
                              <option>GAP Payment</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>On</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <!-- <small for="SaleId"></small> -->
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12">
                              <option>Cash Deals Only</option>
                              <option>Wholesale Deals Only</option>
                              <option>Outside Deals Only</option>
                              <option>BHPH Deals Only</option>
                              <option>All Deals</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="d-flex align-items-center">
                    <td>2</td>
                    <td><input type="number" class="form-control form-control-sm w-45 mb-1 justify-content-center"></td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <!-- <small for="SaleId">Sale</small> -->
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12">
                              <option>Flat Rate</option>
                              <option>%</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>Per</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <!-- <small for="SaleId"></small> -->
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12">
                              <option>Down Payment</option>
                              <option>Sale Front End Profit</option>
                              <option>Sale Back End Profit</option>
                              <option>Scheduled Installment Payment</option>
                              <option>Deferred Down Payment</option>
                              <option>CPI Payment</option>
                              <option>GAP Payment</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>On</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <!-- <small for="SaleId"></small> -->
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12">
                              <option>Cash Deals Only</option>
                              <option>Wholesale Deals Only</option>
                              <option>Outside Deals Only</option>
                              <option>BHPH Deals Only</option>
                              <option>All Deals</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="d-flex align-items-center">
                    <td>3</td>
                    <td><input type="number" class="form-control form-control-sm w-45 mb-1 justify-content-center"></td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <!-- <small for="SaleId">Sale</small> -->
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12">
                              <option>Flat Rate</option>
                              <option>%</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>Per</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <!-- <small for="SaleId"></small> -->
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12">
                              <option>Down Payment</option>
                              <option>Sale Front End Profit</option>
                              <option>Sale Back End Profit</option>
                              <option>Scheduled Installment Payment</option>
                              <option>Deferred Down Payment</option>
                              <option>CPI Payment</option>
                              <option>GAP Payment</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>On</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <!-- <small for="SaleId"></small> -->
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12">
                              <option>Cash Deals Only</option>
                              <option>Wholesale Deals Only</option>
                              <option>Outside Deals Only</option>
                              <option>BHPH Deals Only</option>
                              <option>All Deals</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="d-flex align-items-center">
                    <td>4</td>
                    <td><input type="number" class="form-control form-control-sm w-45 mb-1 justify-content-center"></td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <!-- <small for="SaleId">Sale</small> -->
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12">
                              <option>Flat Rate</option>
                              <option>%</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>Per</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <!-- <small for="SaleId"></small> -->
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12">
                              <option>Down Payment</option>
                              <option>Sale Front End Profit</option>
                              <option>Sale Back End Profit</option>
                              <option>Scheduled Installment Payment</option>
                              <option>Deferred Down Payment</option>
                              <option>CPI Payment</option>
                              <option>GAP Payment</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>On</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <!-- <small for="SaleId"></small> -->
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12">
                              <option>Cash Deals Only</option>
                              <option>Wholesale Deals Only</option>
                              <option>Outside Deals Only</option>
                              <option>BHPH Deals Only</option>
                              <option>All Deals</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- <a href="javascript: void(0);" class="btn btn-primary">Go somewhere</a> -->
              <!-- <button class="btn btn-primary">Show Historical Commission Structures</button> -->
            </div> <!-- end card-body-->
          </div> <!-- end card-->
          <!-- <div class="card">
            </div>
            <div class="card-body">
              <h6 class="card-title">Effective On: 1/1/2020 - 1/1/2021</h6>
              <table class="table table-responsive text-dark">
                <tbody>
                  <tr class="d-flex align-items-center">
                    <td>1</td>
                    <td><input type="number" class="form-control form-control-sm w-45 mb-1 justify-content-center" disabled></td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12">
                              <option>Flat Rate</option>
                              <option>%</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>Per</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Down Payment</option>
                              <option>Sale Front End Profit</option>
                              <option>Sale Back End Profit</option>
                              <option>Scheduled Installment Payment</option>
                              <option>Deferred Down Payment</option>
                              <option>CPI Payment</option>
                              <option>GAP Payment</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>On</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Cash Deals Only</option>
                              <option>Wholesale Deals Only</option>
                              <option>Outside Deals Only</option>
                              <option>BHPH Deals Only</option>
                              <option>All Deals</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="d-flex align-items-center">
                    <td>2</td>
                    <td><input type="number" class="form-control form-control-sm w-45 mb-1 justify-content-center" disabled></td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Flat Rate</option>
                              <option>%</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>Per</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Down Payment</option>
                              <option>Sale Front End Profit</option>
                              <option>Sale Back End Profit</option>
                              <option>Scheduled Installment Payment</option>
                              <option>Deferred Down Payment</option>
                              <option>CPI Payment</option>
                              <option>GAP Payment</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>On</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Cash Deals Only</option>
                              <option>Wholesale Deals Only</option>
                              <option>Outside Deals Only</option>
                              <option>BHPH Deals Only</option>
                              <option>All Deals</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="d-flex align-items-center">
                    <td>3</td>
                    <td><input type="number" class="form-control form-control-sm w-45 mb-1 justify-content-center" disabled></td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Flat Rate</option>
                              <option>%</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>Per</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Down Payment</option>
                              <option>Sale Front End Profit</option>
                              <option>Sale Back End Profit</option>
                              <option>Scheduled Installment Payment</option>
                              <option>Deferred Down Payment</option>
                              <option>CPI Payment</option>
                              <option>GAP Payment</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>On</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Cash Deals Only</option>
                              <option>Wholesale Deals Only</option>
                              <option>Outside Deals Only</option>
                              <option>BHPH Deals Only</option>
                              <option>All Deals</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="d-flex align-items-center">
                    <td>4</td>
                    <td><input type="number" class="form-control form-control-sm w-45 mb-1 justify-content-center" disabled></td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12">
                              <option>Flat Rate</option>
                              <option>%</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>Per</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Down Payment</option>
                              <option>Sale Front End Profit</option>
                              <option>Sale Back End Profit</option>
                              <option>Scheduled Installment Payment</option>
                              <option>Deferred Down Payment</option>
                              <option>CPI Payment</option>
                              <option>GAP Payment</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>On</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Cash Deals Only</option>
                              <option>Wholesale Deals Only</option>
                              <option>Outside Deals Only</option>
                              <option>BHPH Deals Only</option>
                              <option>All Deals</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="card-body">
              <h6 class="card-title">Effective On: 1/1/2021 - 1/1/2022</h6>
              <table class="table table-responsive text-dark">
                <tbody>
                  <tr class="d-flex align-items-center">
                    <td>1</td>
                    <td><input type="number" class="form-control form-control-sm w-45 mb-1 justify-content-center" disabled></td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12">
                              <option>Flat Rate</option>
                              <option>%</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>Per</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Down Payment</option>
                              <option>Sale Front End Profit</option>
                              <option>Sale Back End Profit</option>
                              <option>Scheduled Installment Payment</option>
                              <option>Deferred Down Payment</option>
                              <option>CPI Payment</option>
                              <option>GAP Payment</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>On</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Cash Deals Only</option>
                              <option>Wholesale Deals Only</option>
                              <option>Outside Deals Only</option>
                              <option>BHPH Deals Only</option>
                              <option>All Deals</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="d-flex align-items-center">
                    <td>2</td>
                    <td><input type="number" class="form-control form-control-sm w-45 mb-1 justify-content-center" disabled></td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Flat Rate</option>
                              <option>%</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>Per</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Down Payment</option>
                              <option>Sale Front End Profit</option>
                              <option>Sale Back End Profit</option>
                              <option>Scheduled Installment Payment</option>
                              <option>Deferred Down Payment</option>
                              <option>CPI Payment</option>
                              <option>GAP Payment</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>On</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Cash Deals Only</option>
                              <option>Wholesale Deals Only</option>
                              <option>Outside Deals Only</option>
                              <option>BHPH Deals Only</option>
                              <option>All Deals</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="d-flex align-items-center">
                    <td>3</td>
                    <td><input type="number" class="form-control form-control-sm w-45 mb-1 justify-content-center" disabled></td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Flat Rate</option>
                              <option>%</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>Per</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Down Payment</option>
                              <option>Sale Front End Profit</option>
                              <option>Sale Back End Profit</option>
                              <option>Scheduled Installment Payment</option>
                              <option>Deferred Down Payment</option>
                              <option>CPI Payment</option>
                              <option>GAP Payment</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>On</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Cash Deals Only</option>
                              <option>Wholesale Deals Only</option>
                              <option>Outside Deals Only</option>
                              <option>BHPH Deals Only</option>
                              <option>All Deals</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="d-flex align-items-center">
                    <td>4</td>
                    <td><input type="number" class="form-control form-control-sm w-45 mb-1 justify-content-center" disabled></td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12">
                              <option>Flat Rate</option>
                              <option>%</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>Per</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Down Payment</option>
                              <option>Sale Front End Profit</option>
                              <option>Sale Back End Profit</option>
                              <option>Scheduled Installment Payment</option>
                              <option>Deferred Down Payment</option>
                              <option>CPI Payment</option>
                              <option>GAP Payment</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>On</td>
                    <td>
                      <div class="row mb-1 justify-content-center d-flex">
                        <div class="col-md-12">
                          <div class="input-group">
                            <select class="custom-select form-control form-control-sm text-dark col-md-12" disabled>
                              <option>Cash Deals Only</option>
                              <option>Wholesale Deals Only</option>
                              <option>Outside Deals Only</option>
                              <option>BHPH Deals Only</option>
                              <option>All Deals</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</div>
